"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var PromotionWeekType_1 = require("../../promotion/enums/PromotionWeekType");
/**
 * Utility methods for working with weeks (ISO and PROMO).
 *
 * @author Jan Prokop
 */


var DateWeekUtils =
/*#__PURE__*/
function () {
  function DateWeekUtils() {
    _classCallCheck(this, DateWeekUtils);
  }

  _createClass(DateWeekUtils, null, [{
    key: "getWeek",
    value: function getWeek(year, week) {
      var promotionWeekType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PromotionWeekType_1.PromotionWeekType.Calendar;
      var yearStart = moment({
        year: year
      });

      if (promotionWeekType !== PromotionWeekType_1.PromotionWeekType.Calendar) {
        // use special promo week configuration
        yearStart.locale(promotionWeekType);

        if (week > 0 && week <= yearStart.weeksInYear()) {
          var promoWeek = yearStart.clone(); // Check if 1st of January is in the first week of the year

          if (yearStart.week() !== 1) {
            // If not, add a week to the first day of the current week
            promoWeek.add(1, 'week');
          }

          return promoWeek.week(week);
        }
      } else {
        if (week > 0 && week <= yearStart.isoWeeksInYear()) {
          var calendarWeek = yearStart.clone(); // Check if 1st of January is in the first week of the year

          if (yearStart.isoWeek() !== 1) {
            // If not, add a week to the first day of the current week
            calendarWeek.add(1, 'week');
          }

          return calendarWeek.isoWeek(week);
        }
      }

      return null;
    }
    /**
     * Returns moment date object containing start of the specified week of the specified year, or null
     * if week doesn't exist in that year.
     *
     * @param year
     * @param week
     * @param promotionWeekType
     */

  }, {
    key: "getStartOfWeek",
    value: function getStartOfWeek(year, week) {
      var promotionWeekType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PromotionWeekType_1.PromotionWeekType.Calendar;
      var weekMoment = DateWeekUtils.getWeek(year, week, promotionWeekType);

      if (!weekMoment) {
        return null;
      }

      if (promotionWeekType !== PromotionWeekType_1.PromotionWeekType.Calendar) {
        return weekMoment.startOf('week');
      }

      return weekMoment.startOf('isoWeek');
    }
    /**
     * Returns moment date object containing end of the specified week of the specified year, or null
     * if week doesn't exist in that year.
     *
     * @param year
     * @param week
     * @param promotionWeekType
     */

  }, {
    key: "getEndOfWeek",
    value: function getEndOfWeek(year, week) {
      var promotionWeekType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PromotionWeekType_1.PromotionWeekType.Calendar;
      var weekMoment = DateWeekUtils.getWeek(year, week, promotionWeekType);

      if (!weekMoment) {
        return null;
      }

      if (promotionWeekType !== PromotionWeekType_1.PromotionWeekType.Calendar) {
        return weekMoment.endOf('week');
      }

      return weekMoment.endOf('isoWeek');
    }
    /**
     * Returns start and end date moment tuple of specified week of the specified year, or null
     * if week doesn't exist in that year.
     *
     * @param year
     * @param startWeek
     * @param endWeek
     * @param promotionWeekType
     */

  }, {
    key: "getInterval",
    value: function getInterval(year, startWeek, endWeek) {
      var promotionWeekType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PromotionWeekType_1.PromotionWeekType.Calendar;
      var startDate = DateWeekUtils.getStartOfWeek(year, startWeek, promotionWeekType);

      if (!startDate) {
        return null;
      }

      var endDate = DateWeekUtils.getEndOfWeek(year, endWeek, promotionWeekType);

      if (!endDate) {
        return null;
      }

      return [startDate, endDate];
    }
  }]);

  return DateWeekUtils;
}();

exports.DateWeekUtils = DateWeekUtils;